import { Table, TD, TR } from "@ag-media/react-pdf-table";
import { color, textStyles } from "../../common";
import { normalizeArabic } from "@/v2/utils";

export default function GrandTotalBlock({
    englishLabel,
    amount,
    arabicLabel,
}: {
    englishLabel: string;
    amount: string | number;
    arabicLabel: string;
}) {
    return (
        <Table
            style={{
                border: 0,
                borderTop: 1,
                borderColor: color.brand,
                marginTop: "5px",
            }}
        >
            <TR style={{ marginTop: "5px" }}>
                <TD style={{ fontWeight: 800 }}>{englishLabel}</TD>
                <TD style={{ fontWeight: 800, justifyContent: "center" }}>
                    {amount} SR
                </TD>
                <TD
                    style={{
                        ...textStyles.arabicText,
                        justifyContent: "flex-start",
                    }}
                >
                    {normalizeArabic(arabicLabel)}
                </TD>
            </TR>
        </Table>
    );
}
